import styled from 'styled-components';

export const ContainerMenuPrint = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;
